import ApiService from '@/services/core/api.service'

const LogService = {
  async post (payload) {
    return ApiService.post('user/my-leads/logs', payload)
  }
}

export default LogService
